import { iContact } from "@sdk/crm/crm.models";

export const getContactName = (contact: iContact) => {
  return [contact?.data.firstName, contact?.data.lastName]
    .filter(e => e)
    .join(" ");
};
